<template>
    <div class="d-flex flex-column">
        <div class="mb-3 d-flex justify-content-between align-items-center">
            <h6 style="padding-left: 15px;">Расчёт #{{ item.id }} 
                <b-badge variant="secondary" class="outsource-badge ml-3" v-if="!item.selected_variant">Не утвержден</b-badge>
                <b-badge variant="success" class="outsource-badge ml-3" v-else-if="item.selected_variant">Утвержденный вариант</b-badge>
            </h6>
            <button class="btn btn-outline-green" @click="cancelShowItem">
                Назад
            </button>
        </div>
        <b-container class="line-height">
            <b-row class="mb-4">
                <b-col sm="6" md="6">
                    <b-list-group>
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                            <span for="id">Валюта</span>
                            <span class="font-weight-bold">{{ item.currency }}</span>
                        </b-list-group-item>
                      
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                            <span>Курс валюты на {{ item.purchase_rate }}</span>
                            <span class="font-weight-bold">{{ item.exchange_rate }}</span>
                        </b-list-group-item>
                      
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                            <span>Курс покупки валюты на дату</span>
                            <span class="font-weight-bold">{{ item.purchase_rate }}</span>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>
                <b-col sm="6" md="6">
                    <b-list-group>
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                            <span>Курсовая разница, %</span>
                            <span class="font-weight-bold">{{ item.difference }}</span>
                        </b-list-group-item>
                      
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                            <span>Процент агентской комиссии, %</span>
                            <span class="font-weight-bold">{{ item.percentage_of_agency_commission }}</span>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>
            </b-row>

            <b-row class="mt-5 mb-3">
                <b-col sm="6" md="3" class="mb-5">
                    <span class="text-number">{{ splitSums(+item.cost) }} <span class="text-cur">{{ item.currency }}</span></span>
                    <span class="text-muted">Стоимость товара</span>
                </b-col>
                <b-col sm="6" md="3" class="mb-4">
                    <span class="text-number">{{ splitSums(+item.feasibility_study_to_the_border) }} <span class="text-cur">{{ item.currency }}</span></span>
                    <span class="text-muted">ТЭО до границы ТС</span>
                </b-col>
                <b-col sm="6" md="3" class="mb-4">
                    <span class="text-number">{{ splitSums(+item.total_cost_feasibility_study) }} <span class="text-cur">{{ item.currency }}</span></span>
                    <span class="text-muted">Итого стоимость товара с ТЭО</span>
                </b-col>
                <b-col sm="6" md="3" class="mb-4">
                    <span class="text-number">{{ splitSums(+item.customs_duty) }} <span class="text-cur">{{ item.currency }}</span></span>
                    <span class="text-muted">Таможенный сбор</span>
                </b-col>
                <b-col sm="6" md="3" class="mb-4">
                    <span class="text-number">{{ splitSums(+item.customs_fee) }} <span class="text-cur">{{ item.currency }}</span></span>
                    <span class="text-muted">Таможенная пошлина</span>
                </b-col>
                <b-col sm="6" md="3" class="mb-4">
                    <span class="text-number">{{ splitSums(+item.vat_at_customs) }} <span class="text-cur">{{ item.currency }}</span></span>
                    <span class="text-muted">НДС на Таможне</span>
                </b-col>
                <b-col sm="6" md="3" class="mb-4">
                    <span class="text-number">{{ splitSums(+item.cost_without_vat) }} <span class="text-cur">{{ item.currency }}</span></span>
                    <span class="text-muted">Итого стоимость товара без НДС</span>
                </b-col>
                <b-col sm="6" md="3" class="mb-4" v-if="item.input_percent">
                    <span class="text-number">{{ splitSums(+item.input_percent_sum) }} <span class="text-cur">{{ item.currency }}</span></span>
                    <span class="text-muted">% от входящей суммы</span>
                </b-col>
            </b-row>
            <hr />
            <b-row class="my-4">
                <b-col sm="6" md="3" class="mb-4">
                    <span class="text-number">{{ splitSums(+item.purchase_of_currency) }} <span class="text-cur">{{ item.currency }}</span></span>
                    <span class="text-muted">Покупка валюты и оплата за товар и ТЭО</span>
                </b-col>
                <b-col sm="6" md="3" class="mb-4">
                    <span class="text-number">{{ splitSums(+item.feasibility_study_on_territory) }} <span class="text-cur">{{ item.currency }}</span></span>
                    <span class="text-muted">ТЭО по территории ТС</span>
                </b-col>
                <b-col sm="6" md="3" class="mb-4">
                    <span class="text-number">{{ splitSums(+item.customs_clearance) }} <span class="text-cur">{{ item.currency }}</span></span>
                    <span class="text-muted">Таможенное оформление</span>
                </b-col>
                <b-col sm="6" md="3" class="mb-4">
                    <span class="text-number">{{ splitSums(+item.permits) }} <span class="text-cur">{{ item.currency }}</span></span>
                    <span class="text-muted">Разрешительные документы</span>
                </b-col>
                <b-col sm="6" md="3" class="mb-4">
                    <span class="text-number">{{ splitSums(+item.cargo_insurance) }} <span class="text-cur">{{ item.currency }}</span></span>
                    <span class="text-muted">Страхование груза</span>
                </b-col>
                <b-col sm="6" md="3" class="mb-4">
                    <span class="text-number">{{ splitSums(+item.terminal_rashod) }} <span class="text-cur">{{ item.currency }}</span></span>
                    <span class="text-muted">Терминальные расходы</span>
                </b-col>
                <b-col sm="6" md="3" class="mb-4">
                    <span class="text-number">{{ splitSums(+item.agency_services) }} <span class="text-cur">{{ item.currency }}</span></span>
                    <span class="text-muted">Агентские услуги, комиссия за техимпортера</span>
                </b-col>
                <b-col sm="6" md="3" class="mb-4">
                    <span class="text-number">{{ splitSums(+item.cost_of_goods) }} <span class="text-cur">{{ item.currency }}</span></span>
                    <span class="text-muted">Себестоимость товара</span>
                </b-col>
                <b-col sm="6" md="3" class="mb-4">
                    <span class="text-number">{{ splitSums(+item.vat) }} <span class="text-cur">{{ item.currency }}</span></span>
                    <span class="text-muted">НДС</span>
                </b-col>
                <b-col sm="6" md="3" class="mb-4">
                    <span class="text-number">{{ splitSums(+item.cost_with_vat) }} <span class="text-cur">{{ item.currency }}</span></span>
                    <span class="text-muted">Стоимость с НДС</span>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    methods: {
        cancelShowItem() {
            this.$emit('cancelShowItem');
        },
        splitSums(value) {
            if (typeof value !== "number") {
                return value
            }
            let formatter = new Intl.NumberFormat('ru-RU', {
                minimumFractionDigits: 0
            })
            return formatter.format(value)
        }
    },
}
</script>
<style scoped>
.text-number {
    display: block;
    font-size: 21px;
    font-weight: bold;
    margin-bottom: 1px;
}
.text-muted {
    font-size: 12px;
    line-height: 13px;
}
.text-cur {
    font-size: 14px;
    font-weight: normal;
}
.outsource-badge {
    font-size: 14px;
    font-weight: normal;
}
</style>